<template>
  <div class="c_atom_accordion__title">
    <slot />
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'AccordionTitle',
});
</script>
